import styled from 'styled-components'
import { DeliveryZoneInput } from './DeliveryZoneInput'

export const Container = styled.div<{ $alignment?: string }>`
  position: relative;
  display: flex;
  justify-content: ${props => {
    switch (props.$alignment?.toLowerCase()) {
      case 'left':
        return 'flex-start'
      case 'right':
        return 'flex-end'
      case 'center':
      default:
        return 'center'
    }
  }};
  align-items: center;
`

export const StyledDeliveryZoneInput = styled(DeliveryZoneInput)`
  width: 100%;
  max-width: 291px;
  background: #fff;
`
